import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import './Modal.css';

const EditEventModal = ({ open, onClose, event }) => {
  const [formData, setFormData] = useState({
    name: event.name,
    description: event.description,
    costPerPerson: event.costPerPerson,
    image: event.image,
    date: event.date?.seconds
      ? new Date(event.date.seconds * 1000).toISOString().slice(0, 16)
      : '',
  });

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const eventRef = doc(db, 'events', event.id);

      await updateDoc(eventRef, {
        name: formData.name,
        description: formData.description,
        costPerPerson: Number(formData.costPerPerson),
        image: formData.image,
        date: new Date(formData.date),
      });

      onClose(true);
    } catch (error) {
      console.error('Error updating event:', error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Edit Event</h2>
        <form onSubmit={handleSubmit}>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Event Name"
            required
          />
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Description"
            rows={5}
          />
          <input
            type="number"
            name="costPerPerson"
            value={formData.costPerPerson}
            onChange={handleChange}
            placeholder="Cost (€)"
          />
          <input
            type="text"
            name="image"
            value={formData.image}
            onChange={handleChange}
            placeholder="Image URL"
          />
          <input
            type="datetime-local"
            name="date"
            value={formData.date}
            onChange={handleChange}
          />

          <div className="modal-buttons">
            <button type="submit">Save</button>
            <button type="button" onClick={() => onClose(false)}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEventModal;